export const ROW_HEIGHT = 60;
export const BULK_SELECT_COLUMN_WIDTH = 50;
